module.exports = __webpack_public_path__ + "static/media/bf3.fbc9af39.png";